module.exports = __webpack_public_path__ + "static/portfolio-mas-5-3cadcb12e5ce331399c11f09ecac35c8.jpg";